import api from "service/apiService";
import { ApiResponse } from "types";
import { Survey } from "../types";
import { message } from "antd";
import { translate } from "utils";
import { Answer } from "../type";

export const requestApiGetSurveyDetail = async (id: string) => {
	try {
		const { data } = await api.get<ApiResponse<any>>(`/surveys/${id}`);
		if (data?.data?.data) {
			return data?.data?.data;
		}
	} catch {
		return null;
	}
};

export const requestApiUpdateSurvey = async (survey: any, id: string) => {
	try {
		const { data: response } = await api.patch(`/surveys/${id}`, survey);
		message.success(translate("Update successful"));
		return true;
	} catch (error) {
		return false;
	}
};

export const requestDisableApiUpdateSurvey = async (
	survey: any,
	id: string,
) => {
	try {
		const { data: response } = await api.patch(`/surveys/${id}`, survey);
		return true;
	} catch (error) {
		return false;
	}
};

export const requestApiCreateSurvey = async (survey: any) => {
	try {
		const { data: response } = await api.post(`/surveys`, survey);
		message.success(translate("Create successful"));
		return true;
	} catch (error) {
		return false;
	}
};

interface SurverAnswersResponse {
	data: Answer[];
	extraData: {
		totalQuestion: number;
	};
}

export const getSurveyAnswersAPI = (
	id: string,
): Promise<ApiResponse<Answer[]>> =>
	new Promise((resolve, reject) => {
		api
			.get<ApiResponse<Answer[]>>(`/dashboard/surveys/${id}/answers`)
			.then(res => resolve(res.data))
			.catch(err => reject(err));
	});
